import "@ant-design/v5-patch-for-react-19";
// Font incorporati (OFL): non dipendono da cosa è installato sul PC dell'utente.
import "@fontsource-variable/manrope";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/600.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App as AntApp, ConfigProvider } from "antd";
import itIT from "antd/locale/it_IT";
import enGB from "antd/locale/en_GB";
import dayjs from "dayjs";
import "dayjs/locale/it";
import { useTranslation } from "react-i18next";
import "./i18n";
import { globalCss, theme } from "./theme";
import { AuthProvider } from "./auth/AuthContext";
import App from "./App";

const qc = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false, retry: 1 } } });

function Root() {
  const { i18n } = useTranslation();
  const en = i18n.language === "en";
  dayjs.locale(en ? "en" : "it");
  return (
    <ConfigProvider theme={theme} locale={en ? enGB : itIT}>
      <style>{globalCss}</style>
      <AntApp>
        <QueryClientProvider client={qc}>
          <BrowserRouter>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </AntApp>
    </ConfigProvider>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
